export default __webpack_public_path__ + "static/19-930939b7fe1e4ba79e051903c34c69cc.jpg";